import { useNavigate } from 'react-router-dom';
import { TFunction } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Typography from '../../../componentsv2/Typography';
import Button from '../../../componentsv2/Button';
import Table from '../../../componentsv2/Table';
import NumericText from '../../../componentsv2/NumericText';
import Section from '../../../componentsv2/Section';
import { BANKING_TRANSACTIONS } from '../../../constants/auth';
import { RecentTransaction } from '../../../hooks/useRecentTransactions';
import { EmptyTransactionsIllustration } from './icons';

interface RecentTransactionsTableProps {
  transactions: RecentTransaction[];
  isLoading: boolean;
  language: string;
  t: TFunction;
}

export default function RecentTransactionsTable({
  transactions,
  isLoading,
  language,
  t,
}: RecentTransactionsTableProps) {
  const navigate = useNavigate();
  return (
    <Section>
      <Grid container alignItems="center">
        <Grid item xs={9}>
          <Typography variant="h6" sx={{ fontWeight: '700' }}>
            {t('banking-page:dashboard.recentTransactions.title')}
          </Typography>
        </Grid>
        <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="link"
            color="secondary"
            endIcon="arrowRight"
            onClick={() => navigate(BANKING_TRANSACTIONS)}
          >
            {t('banking-page:dashboard.recentTransactions.viewAllBtn')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Table
            isLoading={isLoading}
            minWidth={0}
            columns={[
              {
                width: 80,
                field: 'date',
                headerName: t('banking-page:dashboard.recentTransactions.columns.date'),
                renderCell: ({ date }) => (
                  <Typography>{new Date(date).toLocaleDateString(language)}</Typography>
                ),
              },
              {
                width: 80,
                field: 'account',
                headerName: t('banking-page:dashboard.recentTransactions.columns.account'),
              },
              {
                width: 180,
                field: 'type',
                headerName: t('banking-page:dashboard.recentTransactions.columns.type'),
                renderCell: ({ type }) =>
                  t(`banking:connectedAccountDetails.transactions.columns.sourceType.values.${type}`),
              },
              {
                field: 'amount',
                headerAlign: 'right',
                headerName: t('banking-page:dashboard.recentTransactions.columns.amount'),
                renderCell: ({ amount, currency }) => (
                  <NumericText sx={{ display: 'flex', justifyContent: 'flex-end' }} currency={currency}>
                    {amount}
                  </NumericText>
                ),
              },
            ]}
            data={transactions}
            emptyMessageTitle={
              !isLoading && transactions.length === 0
                ? t('banking:connectedAccountDetails.transactions.emptyMessageTitle')
                : ''
            }
            emptyMessageIcon={<EmptyTransactionsIllustration />}
          />
        </Grid>
      </Grid>
    </Section>
  );
}
